import React, { FC, ReactNode, useEffect, useState } from 'react';
import styles from './SlideUpPanel.module.css';

interface SlideUpPanelProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    maxWidth?: string;
}

export const SlideUpPanel: FC<SlideUpPanelProps> = ({ isOpen, onClose, children, maxWidth }) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (isOpen) {
            requestAnimationFrame(() => setShow(true));
        } else {
            setShow(false);
        }
    }, [isOpen]);

    return (
        <div className={styles.wrapper}>
            {isOpen && <div className={styles.overlay} onClick={onClose} />}
            <div className={`${styles.panel} ${show ? styles.slideUp : styles.slideDown}`} style={{ maxWidth }}>
                {children}
            </div>
        </div>
    );
};
